import NotFoundPage from "components/error/NotFoundPage";
import PageWrapper from "components/PageWrapper";
import PageLoading from "components/loading/PageLoading";
import Box from "ds/components/Box";
import Card from "ds/components/Card";
import PageInfoHeader from "ds/components/PageInfoHeader";
import useErrorHandle from "hooks/useErrorHandle";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

import OauthRedirectAllowlistForm from "./Form";
import useGetOauthRedirectAllowlist from "./useGetAllowlist";

const OauthRedirectAllowlist = () => {
  const { accountName, viewer } = useTypedContext(AccountContext);

  useTitle(`Organization Settings · OAuth redirect allowlist · ${accountName}`);

  const { allowedHosts, loading, error } = useGetOauthRedirectAllowlist();

  const ErrorContent = useErrorHandle(error);

  if (!viewer.admin) {
    return <NotFoundPage />;
  }

  if (ErrorContent) {
    return ErrorContent;
  }

  if (loading && !allowedHosts) {
    return <PageLoading />;
  }

  return (
    <>
      <PageInfoHeader title="OAuth redirect allowlist" />
      <PageWrapper>
        <Box direction="column" limitWidth="medium" gap="x-large" fullWidth>
          <Card>
            <Box direction="column" fullWidth>
              <OauthRedirectAllowlistForm currentHosts={allowedHosts} />
            </Box>
          </Card>
        </Box>
      </PageWrapper>
    </>
  );
};

export default OauthRedirectAllowlist;
